/* Index_object_icon_content_marquee */
initMarquee('.Index_object_icon_content_marquee', {
    mobile: {
        duration: 50000,
        gap: 0,
        duplicated: true,
        direction: "left"
    },
    desktop: {
        duration: 80000,
        gap: 0,
        duplicated: true,
        direction: "left"
    }
});
/* Index_object_icon_content_marquee */